import script from "./image-material-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./image-material-upload.vue?vue&type=script&setup=true&lang=js"

import "./image-material-upload.vue?vue&type=style&index=0&id=67df0b14&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67df0b14"]])

export default __exports__